import { FormEvent, ReactNode } from 'react';
import { Channel } from '@domain/channel';

export const CHANNELS_SALES_QUOTA_UNLIMITED = 'unlimited';
export const CHANNELS_SALES_QUOTA_ALL = 'all';
export const CHANNELS_SALES_QUOTA_CHANNEL = 'channel';

export type SalesQuotaChannelType =
  | typeof CHANNELS_SALES_QUOTA_UNLIMITED
  | typeof CHANNELS_SALES_QUOTA_ALL
  | typeof CHANNELS_SALES_QUOTA_CHANNEL;

export interface SelectedChannel {
  id: string;
  name: string;
  slug: string;
  value: string;
  checked: boolean;
  originalIndex: number;
}

export interface InputSearchChannelsTranslations {
  tooltip: string;
  title: string;
  selectValue: string;
  titleLimitAll: string;
  multiSearchTranslations: {
    deselectAll: string;
    selectAll: string;
    noResultsFound: string;
    noOptionsSelected: string;
    searchLabel: string;
    searchPlaceholder: string;
  };
}

export interface InputSelectChannelsProps {
  translations: InputSearchChannelsTranslations;
  selectedChannels: SelectedChannel[];
  channelOptions: Channel[];
  wrapperRef?: React.RefObject<HTMLDivElement | HTMLFormElement>;
  selectTypeOptions: ReactNode;
  setChannelSelection: (value: Channel[]) => void;
  readOnly?: boolean;
}

export interface InputChannelValueProps {
  channel: SelectedChannel;
  index: number;
  onChange: (e: FormEvent<HTMLInputElement>) => void;
  hasChannelError: (index: number) => boolean;
}
